import { useUserRoles } from '@anytag/auth';
import { AutoManagedCampaignPayload, MarketplaceCampaignDetailType } from '@anytag/graphql';
import { Form } from '@anytag/shared-atoms';
import { DefaultFormProps } from '../types';
import { getMarketplaceInitialFormValues } from '../utils';
import { getEcommerceCampaignFormSchema } from './schema';
import { Template } from './Template';

export interface EcommerceCampaignFormProps extends DefaultFormProps {
  autoManagedCampaignData?: AutoManagedCampaignPayload | null;
}

export const EcommerceCampaignForm = ({
  data,
  onSubmit,
  disabledFields,
  defaultAdvertiser,
  autoManagedCampaignData
}: EcommerceCampaignFormProps) => {
  const { role } = useUserRoles();

  const defaultValues = getMarketplaceInitialFormValues({
    data,
    defaultAdvertiser,
    autoManagedCampaignData,
    campaignType: MarketplaceCampaignDetailType.E_COMMERCE
  });

  return (
    <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={getEcommerceCampaignFormSchema(role)}>
      <Template defaultValues={defaultValues} disabledFields={disabledFields} />
    </Form.Provider>
  );
};
